import { z } from 'zod';
import { MAX_INTEGER, MIN_INTEGER } from '../../../../config/constants';

const MIN_VALUE = MIN_INTEGER;
const MAX_VALUE = MAX_INTEGER;

const numberSchema = z
  .number({
    invalid_type_error: 'Numeric value required.',
  })
  .gte(MIN_VALUE)
  .lte(MAX_VALUE)
  .int();

export const validationSchema = z
  .object({
    min: numberSchema,
    max: numberSchema,
  })
  .superRefine((values, ctx) => {
    if (values.min >= values.max) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: `Must be greater than min bound.`,
        path: ['max'],
        fatal: true,
      });

      return z.NEVER;
    }
  });
